import getPayments from './fetchPayments';
import getBanks from './fetchBanks';
import getPaid from './getPaid';

export default {
  getPayments,
  getBanks,
  getPaid,
};
